<span *ngIf="showEditor && (key || infoBubble || value || dataPath)" class="dcr-content-edit">
	<section *ngIf="key">
		LABEL: <a [href]="keyEdit | dcrKey">{{ key | dcrKey }}</a>
	</section>
	<br />
	<section *ngIf="value">
		VALUE: <a [href]="valueEdit">{{ value }}</a>
	</section>
	<br />
	<section *ngIf="dataPath">
		DATAPATH: <a [href]="dataPathEdit">{{ dataPath }}</a>
	</section>
	<br />
	<section *ngIf="infoBubble">
		INFOBUBBLE: <a [href]="infoBubbleEdit | dcrKey">{{ infoBubble | dcrKey }}</a>
	</section>
	<br />
</span>
